export default class SearchType {
    constructor() {
        this.DateRange = 'DateRange';
        this.BailAgent = 'BailAgent';
    }
}